import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Ladataan...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirectPath = `${location.pathname}${location.search}`;
    const encodedRedirect = encodeURIComponent(redirectPath);
    return <Navigate to={`/auth?redirect=${encodedRedirect}`} replace />;
  }

  // If terms not accepted, redirect to auth to show terms modal
  if (user && !user.terms_accepted_at) {
    const redirectPath = `${location.pathname}${location.search}`;
    const encodedRedirect = encodeURIComponent(redirectPath);
    return <Navigate to={`/auth?redirect=${encodedRedirect}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
